import CTATileBlock from './CTATileBlock';

export default CTATileBlock;
